import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { commandApi } from 'src/api';

export const createCommand = createAsyncThunk('command/create-command', async (data, thunkApi) => {
  try {
    const { payload, onCancel } = data;

    const response = await commandApi.createCommand(payload);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchCommands({}));

    if (onCancel) {
      onCancel();
    }

    return response.data;
  } catch (error) {
    console.error('createCommand[error]', error);

    const message = error?.response?.data?.message || 'Something went wrong';

    toast(message, { type: 'error' });

    return thunkApi.rejectWithValue(message);
  }
});

export const fetchCommands = createAsyncThunk('command/fetch-commands', async (data, thunkApi) => {
  try {
    const response = await commandApi.fetchCommands(data);

    return response.data;
  } catch (error) {
    console.error('fetchCommands[error]', error);

    const message = error?.response?.data?.message || 'Something went wrong';

    toast(message, { type: 'error' });

    return thunkApi.rejectWithValue(message);
  }
});

export const updateCommand = createAsyncThunk('command/update-command', async (data, thunkApi) => {
  try {
    const { id, payload, onCancel } = data;

    const response = await commandApi.updateCommand(id, payload);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchCommands({}));

    if (onCancel) {
      onCancel();
    }

    return response.data;
  } catch (error) {
    console.error('updateCommand[error]', error);

    const message = error?.response?.data?.message || 'Something went wrong';

    toast(message, { type: 'error' });

    return thunkApi.rejectWithValue(message);
  }
});

export const deleteCommand = createAsyncThunk('command/delete-command', async (data, thunkApi) => {
  try {
    const { id } = data;

    const response = await commandApi.deleteCommand(id);

    toast(response.data.message, { type: 'success' });

    thunkApi.dispatch(fetchCommands({}));

    return response.data;
  } catch (error) {
    console.error('deleteCommand[error]', error);

    const message = error?.response?.data?.message || 'Something went wrong';

    toast(message, { type: 'error' });

    return thunkApi.rejectWithValue(message);
  }
});
